import { useState } from "react";
import { useAuth } from "../../contexts/auth";
import AppLogo from "./../../assets/imgs/yamaha-logo-white.png";
import * as S from "./styles";

export const LoginPage = () => {
  const { login } = useAuth();

  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");

    const formData = new FormData(e.currentTarget);
    const username = formData.get("username")?.toString();
    const password = formData.get("password")?.toString();

    if (!username || !password) {
      setErrorMessage("Por favor, preencha todos os campos");
      return null;
    }

    try {
      await login({ username, password });
    } catch (error) {
      setErrorMessage(error.message || "Erro ao autenticar usuário.");
    }
  };

  return (
    <S.Container>
      <S.FormContainer>
        <div id="logo-container">
          <img src={AppLogo} alt="Yamaha - Revs Your Heart" />
        </div>
        <h1>Check Yamaha</h1>
        <form onSubmit={handleSubmit}>
          <h2>Login</h2>
          <input
            type="text"
            id="username"
            name="username"
            placeholder="Usuário"
          />
          <input
            type="password"
            id="password"
            name="password"
            autoComplete="current-password"
            placeholder="Senha"
          />
          <span className="error-message">{errorMessage}</span>
          <button
            type="submit"
            style={{
              backgroundColor: "var(--color-purple)",
              color: "#fff",
            }}
          >
            Entrar
          </button>
        </form>
      </S.FormContainer>
    </S.Container>
  );
};
